var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6924 5.08447V12.9172C16.6924 13.825 15.9564 14.561 15.0486 14.561H2.64376C1.73593 14.561 1 13.825 1 12.9172V2.578C1 1.7065 1.7065 1 2.578 1H5.85013C6.4963 1 7.10663 1.29692 7.50548 1.8053L8.87239 3.54759C8.93887 3.63232 9.04059 3.6818 9.14828 3.6818H15.2897C16.0644 3.6818 16.6924 4.3098 16.6924 5.08447Z",
    fill: "#FAFAFA",
    stroke: "black",
    strokeWidth: 1.74357
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7925 14.5H2.41343C1.72348 14.5 1.24081 13.8178 1.47044 13.1672L3.76456 6.66718C3.90567 6.26737 4.28356 6 4.70755 6H18.0866C18.7766 6 19.2593 6.6822 19.0296 7.33282L16.7355 13.8328C16.5944 14.2326 16.2165 14.5 15.7925 14.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05745 6.41756C3.30439 5.71789 3.96571 5.25 4.70768 5.25H18.0868C19.2942 5.25 20.1389 6.44385 19.737 7.58244L17.4429 14.0824C17.1959 14.7821 16.5346 15.25 15.7927 15.25H2.41357C1.20615 15.25 0.361478 14.0562 0.763332 12.9176L3.05745 6.41756ZM4.70768 6.75C4.60169 6.75 4.50721 6.81684 4.47194 6.91679L2.17782 13.4168C2.12041 13.5794 2.24108 13.75 2.41357 13.75H15.7927C15.8986 13.75 15.9931 13.6832 16.0284 13.5832L18.3225 7.0832C18.3799 6.92055 18.2593 6.75 18.0868 6.75H4.70768Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.d744ec47045d45561e8045fec22aa84c.svg";
export { ForwardRef as ReactComponent };